/**
 * Canonical identity for the MOCKED frontend E2E user.
 *
 * Single source of truth — imported by all three sites that need it:
 *  - frontend/e2e/fixtures/mocked-test.fixture.ts  (Playwright @mocked auth interception)
 *  - frontend/e2e/mock.setup.ts                    (storageState seed)
 *  - frontend/src/components/auth/SupabaseAuthProvider.tsx (dev-only mock-auth bypass)
 *
 * This is a FAKE identity — no real Supabase account exists behind it. The
 * @mocked Playwright suite intercepts every auth/network call, so these values
 * never authenticate against anything.
 *
 * For the REAL Supabase-login E2E user (the `e2e-frontend-real@lexomat.sk`
 * account that the browser regression suite logs in as), see
 * E2E_USER_EMAIL / E2E_USER_PASSWORD in frontend/.env.e2e.template.
 *
 * The backend HTTP/TaskIQ E2E user is a separate identity again —
 * the `user_e2e_backend_lexomat` DB row (see backend/.../tests/e2e/conftest.py).
 */
export const E2E_MOCK_USER_ID = 'e2e-mock-user-id';
export const E2E_MOCK_USER_EMAIL = 'e2e-frontend-mock@lexomat.sk';
export const E2E_MOCK_USER_FULL_NAME = 'E2E Mock User';
